<template>
  <div class="manage_container">
    <div class="list_search">
      <filterCondition></filterCondition>
    </div>
    <div class="list_content">
      <tableList></tableList>
    </div>
  </div>
</template>

<script>
import '../../less/custom.less'
import './index.less'


import { Table, Form, Input, Button,Select, DatePicker, Icon, Result,Modal } from 'ant-design-vue'
const { Item: FormItem } = Form

import filterCondition from './filterCondition/filterCondition.vue'
import tableList from './tableList/tableList.vue'


import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('manage')


export default {
  name: "LicenseManage",
  data() {
    return {
    }
  },
  created() {
  },
  mounted(){
  },
  methods: {

  },
  components: {
    filterCondition,
    tableList
  },
}
</script>
